// extracted by mini-css-extract-plugin
export default {"content":"SagvbD9rzIvFKpwSlNzA","previewCard":"TqCa2ABEJPgNqI3f5nVn","previewIcon":"NRLGOq46BjOPQv_GJez0","previewSpin":"NclnPYrkZNdbEkrm0dZy","footer":"tNWsWIbjvfH1NGTB3x5L"};